
<template>
    <div class="w-full table">
      <el-table
        class="w-full"
        v-loading="loading"
        :data="dataSource"
        empty-text="暂无数据"
        :height="h"
        :header-cell-style="headerStyle"
      >
        <el-table-column
          v-for="item in columns"
          :key="item.prop"
          v-bind="{ ...item }"
          :show-overflow-tooltip="tooltip"
        >
          <template #default="scope" v-if="item.scopedSlots && !columns.children">
            <slot :name="item.scopedSlots" v-bind="{ ...scope }"></slot>
          </template>
          
          <el-table-column
            v-for="data in item.children"
            :key="data.prop"
            v-bind="{ ...data }"
            :show-overflow-tooltip="tooltip"
          >
            <template #default="scope" v-if="data.scopedSlots">
              <slot :name="data.scopedSlots" v-bind="{ ...scope }"></slot>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <!--  只有一页不显示分页 -->
      <el-pagination
        class="pageination flex items-center justify-end"
        layout="total, prev, pager, next,sizes"
        :hide-on-single-page='!showSize'
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :page-sizes="showSize ? [10, 20, 50, 100, 500] : []"
        :current-page="pagination.pageNum"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>
  </template>
  
  <script>
  export default {
    name: 'STable',
    props: {
      columns: {
        type: Array,
        default: () => []
      },
      loadData: {
        type: Function,
        default: () => () => {},
        required: true
      },
      size: {
        type: Number,
        default: 10
      },
      tooltip: {
        type: Boolean,
        default: true
      },
      showSize: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        loading: false,
        pagination: {
          pageNum: 1,
          pageSize: this.size,
          total: 0
        },
        dataSource: [],
        h: null
      };
    },
    created () {
      this.refresh(true);
    },
    methods: {
      async refresh (bool = false) {
        if (bool) {
          this.pagination.pageNum = 1;
          this.pagination.total = 0;
          this.dataSource = [];
        }
        const { pageNum, pageSize } = this.pagination;
        const result = await this.bindLoading({ pageNum, pageSize });
        this.dataSource = result.data.dataList || [];
        this.pagination.total = result.data.totalCount || 0;
      },
      // 换页
        handleCurrentChange(pageNum) {
        this.pagination.pageNum = pageNum;
        this.refresh();
      },
      handleSizeChange (pageSize) {
        this.pagination.pageSize = pageSize;
        this.refresh();
      },
      bindLoading (params) {
        return new Promise((resolve) => {
          this.loading = true;
          this.loadData(params)
            .then((rs) => resolve(rs))
            .finally(() => (this.loading = false));
        });
      },
      headerStyle({ row, rowIndex }) {
       if(rowIndex == 1) row.forEach((item,index) => {
            if (item.label === '缺勤时间') {
              item.colSpan = 2
           }
           if (item.property &&item.property!== 'realDutyTime' && item.property.split('duty')[1] === 'Time' && item.colSpan === 1) {
             item.colSpan = 2
              if(item.id.indexOf('br') === -1) item.id = item.id + ' br'
           }
           if (item.label === '') {
            if(item.id.indexOf('none') === -1) item.id = item.id + ' none'
           }
        })
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .w-full{
      width: 100%;
  }
  .pageination {
    margin: 20px 0 10px;
    text-align: right;
  }
  </style>
  
  <style lang="scss">
  .table{
      thead{
         .el-table__cell{
            padding: 5px 0;
          }
          th{
           background-color: #ededed;
          }   
          .br{
            border-left: 1px solid #EBEEF5;
            border-right: none !important;
           }
           .none{
             display: none;
           }
      }
      tbody{
         .el-table__cell{
            padding: 10px 0;
          }
          .el-checkbox__label{
            display: none;
          }
      }
      a{
          text-decoration:none;
          color:#409EFF;
          margin-right: 10px;
          font-size: 14px;
      }
      .success{
          color: #67C23A;
      }
      .delete{
          color: #F56C6C;
      }
  
  }
  .el-table--scrollable-x
  .el-table__body-wrapper {
    position: relative;
    // z-index: 10;
}
  </style>
  